import { useLingui } from '@lingui/react/macro';
import Selector from 'modules/template-editor/ui/components/elements/selector';
import React, { useMemo } from 'react';
import { fontWeightChoices, normalizeFontWeight, primaryFontFamily } from 'shared/fonts';

interface FontWeightSelectProps {
  /** Шрифт объекта — от него зависят пункты. */
  fontFamily: string | undefined;
  /** Сохранённое начертание: число или старое `normal` / `bold` / `lighter`. */
  value: string | number | undefined;
  onChange: (weight: number) => void;
  className?: string;
}

/**
 * «Начертание» редактора трансляций — только веса выбранного шрифта из реестра, подписи через Lingui.
 * Пишет число; старые ключевые слова читаются через `normalizeFontWeight`.
 */
function FontWeightSelect({ fontFamily, value, onChange, className }: FontWeightSelectProps) {
  const { t } = useLingui();
  const family = primaryFontFamily(fontFamily);
  const options = useMemo(
    () =>
      fontWeightChoices(family, value).map((choice) => ({
        value: String(choice.value),
        label: choice.label ? `${t(choice.label)} (${choice.value})` : String(choice.value),
      })),
    [family, t, value],
  );
  const selected = String(normalizeFontWeight(value, family));

  return (
    <Selector
      className={className}
      onChange={(option) => {
        if (option?.value) onChange(Number(option.value));
      }}
      options={options}
      value={options.find((option) => option.value === selected) ?? null}
    />
  );
}

export default FontWeightSelect;
